import React from 'react';
import { Inbox, Loader2 } from 'lucide-react';
import { EmptyState } from '../../components/ui/PageLayout';

export default function MembersRequestsTab({ requests, grantingRequestId, handleGrantRequest }: any) {
  return (
    <div role="tabpanel" id="members-tabpanel-requests" aria-labelledby="members-tab-requests">
      <section>
        {requests.length === 0 ? (
          <EmptyState
            icon={<Inbox className="w-12 h-12 text-slate-500" />}
            title="No pending access requests"
            description="When someone requests access from the landing page, their request will appear here."
          />
        ) : (
          <div className="cards-grid-mdl-dense">
            {requests.map((req) => {
              const messageText = req.message ? String(req.message).trim() : '';
              const truncated =
                messageText.length > 100 ? `${messageText.slice(0, 100)}…` : messageText;
              return (
                <div
                  key={req.id}
                  className="card-mdl p-4 flex flex-col gap-3 sm:flex-row sm:items-start"
                >
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-dark-elevated flex items-center justify-center">
                    <Inbox className="w-5 h-5 text-brand-purple-light" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="font-medium text-slate-100">{req.name}</p>
                    <p className="text-sm text-slate-400 truncate">{req.email}</p>
                    {messageText ? (
                      <p className="mt-2 text-sm text-slate-300" title={messageText}>
                        {truncated}
                      </p>
                    ) : null}
                    <p className="mt-2 text-xs text-slate-500">
                      Submitted{' '}
                      {req.createdAt
                        ? new Date(req.createdAt).toLocaleString(undefined, {
                            dateStyle: 'medium',
                            timeStyle: 'short',
                          })
                        : '—'}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => handleGrantRequest(req.id, req.email)}
                    disabled={grantingRequestId === req.id}
                    className="btn-primary-mdl shrink-0 inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {grantingRequestId === req.id ? (
                      <>
                        <Loader2 className="w-4 h-4 animate-spin" aria-hidden />
                        Sending…
                      </>
                    ) : (
                      'Grant access'
                    )}
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
}
